import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type {
  ApprovalListItemInterface,
  ApprovalListPaginationInterface,
  ApprovalLogItemInterface,
  ApprovalWorkflowDataInterface,
} from 'features/ApprovalEngine/@types/ApprovalListTypes'

const emptyApprovalLogsPagination: ApprovalListPaginationInterface = {
  page_size: 0,
  page_item: 0,
  previous_cursor: '',
  next_cursor: '',
  next_page_exist: false,
  previous_page_exist: false,
  cursor_direction: '',
  page_cursor: '',
}

interface ApprovalEngineDetailStateType {
  isLoading: boolean
  detail: ApprovalListItemInterface | null
  isLoadingApprovalLogs: boolean
  approvalLogs: ApprovalLogItemInterface[]
  approvalLogsPagination: ApprovalListPaginationInterface
  isLoadingWorkflow: boolean
  workflow: ApprovalWorkflowDataInterface | null
}

const initialState: ApprovalEngineDetailStateType = {
  isLoading: false,
  detail: null,
  isLoadingApprovalLogs: false,
  approvalLogs: [],
  approvalLogsPagination: emptyApprovalLogsPagination,
  isLoadingWorkflow: false,
  workflow: null,
}

const approvalEngineDetailSlice = createSlice({
  name: 'approvalEngineDetail',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setDetail: (state, action: PayloadAction<ApprovalListItemInterface | null>) => {
      state.detail = action.payload
    },
    setIsLoadingApprovalLogs: (state, action: PayloadAction<boolean>) => {
      state.isLoadingApprovalLogs = action.payload
    },
    setApprovalLogs: (state, action: PayloadAction<ApprovalLogItemInterface[]>) => {
      state.approvalLogs = action.payload
    },
    setApprovalLogsPagination: (state, action: PayloadAction<ApprovalListPaginationInterface>) => {
      state.approvalLogsPagination = action.payload
    },
    setIsLoadingWorkflow: (state, action: PayloadAction<boolean>) => {
      state.isLoadingWorkflow = action.payload
    },
    setWorkflow: (state, action: PayloadAction<ApprovalWorkflowDataInterface | null>) => {
      state.workflow = action.payload
    },
    resetApprovalEngineDetail: () => initialState,
  },
})

export const {
  setIsLoading,
  setDetail,
  setIsLoadingApprovalLogs,
  setApprovalLogs,
  setApprovalLogsPagination,
  setIsLoadingWorkflow,
  setWorkflow,
  resetApprovalEngineDetail,
} = approvalEngineDetailSlice.actions

export default approvalEngineDetailSlice.reducer
